import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px #cad8ee70;
  overflow: hidden;
  padding: 16px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Label = styled.label`
  font-family: 'Biotif', 'Segoe UI', Arial, sans-serif;
  font-size: 16px;
  color: #707070;

  select {
    margin-left: 8px;
    padding: 6px 10px;
    font-family: 'Biotif', sans-serif;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: 'Biotif', 'Segoe UI', Arial, sans-serif;
`;

export const TableHead = styled.thead`
  background: #f5f7fa;

  tr th {
    color: #9399b2;
    font-weight: bold;
    font-size: 18px;
    padding: 14px 24px;
    border-bottom: 1px solid #e3e7ed;
    text-align: left;
    letter-spacing: 0.02em;
  }

  tr th:last-child {
    text-align: right;
  }
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid #e3e7ed;
    background: #fff;

    &:nth-child(odd) {
      background: #f6f8fb;
    }
  }

  tr {
    border-bottom: 1px solid #e3e7ed;
    background: #fff; /* default white */

    &:nth-child(odd) {
      background: #f6f8fb; /* light color on even rows */
    }
  }

  td {
    color: #4a4c5b;
    font-size: 16px;
    padding: 14px 24px;
    text-align: left;
    vertical-align: middle;
  }

  tr td:last-child {
    text-align: right;
  }
`;

export const EmptyRow = styled.tr`
  td {
    text-align: center;
    color: #9399b2;
    padding: 24px;
    font-size: 16px;
  }
`;

export const LoadingText = styled.p`
  font-family: 'Biotif', sans-serif;
  font-size: 16px;
  color: #707070;
  text-align: center;
`;

export const ErrorText = styled(LoadingText)`
  color: #ff4d4f;
`;
